var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11110",
    "data-name": "Group 11110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.566,
    height: 20.688,
    viewBox: "0 0 24.566 20.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3279",
    "data-name": "Rectangle 3279",
    width: 24.566,
    height: 20.688,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11101",
    "data-name": "Group 11101",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29033",
    "data-name": "Path 29033",
    d: "M24.566,329.883v7.59a2.585,2.585,0,0,1-2.586,2.586H2.586A2.577,2.577,0,0,1,0,337.473v-2.211l3.039-3.077a2.59,2.59,0,0,1,3.659,0l.53.53a2.591,2.591,0,0,0,3.659,0l6.465-6.452a2.575,2.575,0,0,1,3.646,0Z",
    transform: "translate(0 -319.371)",
    fill: "#91de6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29034",
    "data-name": "Path 29034",
    d: "M21.98,0H2.586A2.585,2.585,0,0,0,0,2.586v13.3l3.039-3.077a2.591,2.591,0,0,1,3.659,0l.53.53a2.591,2.591,0,0,0,3.659,0l6.465-6.452a2.575,2.575,0,0,1,3.646,0l3.569,3.62V2.586A2.593,2.593,0,0,0,21.98,0M9.051,9.051a2.586,2.586,0,1,1,2.586-2.586A2.577,2.577,0,0,1,9.051,9.051",
    fill: "#95f2fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29035",
    "data-name": "Path 29035",
    d: "M348.172,208.386a2.586,2.586,0,1,1-2.586-2.586,2.585,2.585,0,0,1,2.586,2.586",
    transform: "translate(-336.535 -201.921)",
    fill: "#ffed7d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/imgIcon.643c2471ae07d9fc17e0a9fe87a36fca.svg";
export { ForwardRef as ReactComponent };